import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemComponent } from './modules/core/components/system/system.component';
import { NotFoundComponent } from './modules/core/components/not-found/not-found.component';
import { AuthGuard } from './guards/auth.guard';
import { moduleGuard } from './guards/module.guard';
import { UnauthorizedComponent } from './modules/core/components/unauthorized/unauthorized.component';

const routes: Routes = [
  {
    path: "",
    children: [
      { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
      {
        path: "auth",
        loadChildren: () => import('./modules/feature/login/login.module').then(m => m.LoginModule),
      },
      {
        path: "app", component: SystemComponent,
        canActivate: [AuthGuard],
        children: [
          { path: '', redirectTo: 'homepage', pathMatch: 'full' },
          {
            path: 'homepage',
            loadChildren: () => import('./modules/feature/homepage/homepage.module').then(m => m.HomepageModule),
          },
          {
            path: 'energy',
            loadChildren: () => import('./modules/feature/energy-management/energy-management.module').then(m => m.EnergyManagementModule),
            canActivate: [moduleGuard],
            data: { modules: ['Energy'] }
          },
          {
            path: 'solar-management',
            loadChildren: () => import('./modules/feature/solar-management/solar-management.module').then(m => m.SolarManagementModule),
          },
          {
            path: 'schedule-management',
            loadChildren: () => import('./modules/feature/schedule/schedule.module').then(m => m.ScheduleModule),
            canActivate: [moduleGuard],
            data: { modules: ['Schedule'] }
          },
          {
            path: 'schedule',
            children: [
              { path: '', redirectTo: '/app/schedule-management/schedule-list', pathMatch: 'full' },
              { path: 'schedule-list', redirectTo: '/app/schedule-management/schedule-list', pathMatch: 'full' },
              { path: 'schedule-list/add-schedule', redirectTo: '/app/schedule-management/schedule-list/add-schedule', pathMatch: 'full' },
              { path: 'schedule-list/edit-schedule/:id', redirectTo: '/app/schedule-management/schedule-list/edit-schedule/:id', pathMatch: 'full' },
              { path: 'schedule-overview', redirectTo: '/app/schedule-management/schedule-overview', pathMatch: 'full' },
            ]
          },
          {
            path: 'water',
            loadChildren: () => import('./modules/feature/water-management/water-management.module').then(m => m.WaterManagementModule),
            canActivate: [moduleGuard],
            data: { modules: ['Water'] }
          },
          {
            path: 'mosque-management',
            loadChildren: () => import('./modules/feature/mosque-management/mosque-management.module').then(m => m.MosqueManagementModule),
          },
          {
            path: 'environment',
            loadChildren: () => import('./modules/feature/environment/environment.module').then(m => m.EnvironmentModule),
            canActivate: [moduleGuard],
            data: { modules: ['Environment'] }
          },
          {
            path: 'appliance',
            loadChildren: () => import('./modules/feature/appliance/appliance.module').then(m => m.ApplianceModule),
            canActivate: [moduleGuard],
            data: { modules: ['Control'] }
          },
          {
            path: 'fire-alarm',
            loadChildren: () => import('./modules/feature/fire-alarm/fire-alarm.module').then(m => m.FireAlarmModule),
            // canActivate: [moduleGuard],
            // data: { modules: ['FireAlarm'] }
          },
          {
            path: 'hvac',
            loadChildren: () => import('./modules/feature/hvac/hvac.module').then(m => m.HvacModule),
            // canActivate: [moduleGuard],
            // data: { modules: ['Hvac'] }
          },
          {
            path: 'lift-system',
            loadChildren: () => import('./modules/feature/lift-system/lift-system.module').then(m => m.LiftSystemModule),
            // canActivate: [moduleGuard],
            // data: { modules: ['LiftSystem'] }
          },
          {
            path: 'access-control',
            loadChildren: () => import('./modules/feature/access-control/access-control.module').then(m => m.AccessControlModule),
            // canActivate: [moduleGuard],
            // data: { modules: ['AccessControl'] }
          },
          {
            path: 'occupancy',
            loadChildren: () => import('./modules/feature/occupancy/occupancy.module').then(m => m.OccupancyModule),
            // canActivate: [moduleGuard],
            // data: { modules: ['Occupancy'] }
          },
          {
            path: 'parking',
            loadChildren: () => import('./modules/feature/parking/parking.module').then(m => m.ParkingModule),
            // canActivate: [moduleGuard],
            // data: { modules: ['Parking'] }
          },
          {
            path: 'asset',
            loadChildren: () => import('./modules/feature/asset/asset.module').then(m => m.AssetModule),
            canActivate: [moduleGuard],
            data: { modules: ['Assets'] }
          },
          {
            path: 'preventive-maintenance',
            loadChildren: () => import('./modules/feature/preventive-maintenance/preventive-maintenance.module').then(m => m.PreventiveMaintenanceModule),
          },
          {
            path: 'network',
            loadChildren: () => import('./modules/feature/network/network.module').then(m => m.NetworkModule),
            // canActivate: [moduleGuard],
            // data: { modules: ['Network'] }
          },
          {
            path: 'system-settings',
            loadChildren: () => import('./modules/feature/system-settings/system-settings.module').then(m => m.SystemSettingsModule),
          },
          {
            path: 'account',
            loadChildren: () => import('./modules/feature/account/account.module').then(m => m.AccountModule),
          },
          {
            path: 'alarms',
            loadChildren: () => import('./modules/feature/alarms/alarms.module').then(m => m.AlarmsModule),
            canActivate: [moduleGuard],
            data: { modules: ['Notifications'] }
          },
        ]
      },
      // { path: 'unauthorized', component: UnauthorizedComponent, pathMatch: 'full' },
      { path: '**', component: NotFoundComponent, pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
